import React from "react";
import { Link } from "react-router-dom";
import { FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import { Translate, I18n } from "react-redux-i18n";
import MiniLoader from "./MiniLoader";
import "./styles/PasswordResetForm.css";

class PasswordResetForm extends React.Component {
  state = {
    showPassword: false,
    showPasswordConfirm: false,
  };

  togglePassword = () => {
    this.setState((prev) => ({ showPassword: !prev.showPassword }));
  };

  togglePasswordConfirm = () => {
    this.setState((prev) => ({ showPasswordConfirm: !prev.showPasswordConfirm }));
  };

  handleSubmit = (e) => {
    e.preventDefault();
    if (!this.props.submitDisabled && !this.props.loading && this.props.onSubmit) {
      this.props.onSubmit(e);
    }
  };

  render() {
    const {
      password,
      passwordConfirm,
      touched,
      submitDisabled,
      loading,
      passwordWeak,
      passwordsMismatch,
      onChange,
      onBlur,
    } = this.props;

    const passwordError = touched.password && !password;
    const confirmError = touched.passwordConfirm && !passwordConfirm;
    const weakError = touched.password && password && passwordWeak;
    const mismatchError =
      touched.passwordConfirm && passwordConfirm && passwordsMismatch;

    return (
      <div className="password-reset-page">
        <div className="password-reset-card">
          <div className="password-reset-card__icon" aria-hidden="true">
            <FaLock />
          </div>

          <header className="password-reset-card__header">
            <h1 className="password-reset-card__title">
              <Translate value="password_change" />
            </h1>
            <p className="password-reset-card__subtitle">
              <Translate value="password_tip" />
            </p>
          </header>

          <form className="password-reset-form" onSubmit={this.handleSubmit} noValidate>
            <div className="password-reset-form__field">
              <label className="password-reset-form__label" htmlFor="reset_password">
                <Translate value="password_new" />
              </label>
              <div
                className={`password-reset-form__input-wrap${
                  passwordError || weakError ? " password-reset-form__input-wrap--invalid" : ""
                }`}
              >
                <span className="password-reset-form__input-icon" aria-hidden="true">
                  <FaLock />
                </span>
                <input
                  id="reset_password"
                  type={this.state.showPassword ? "text" : "password"}
                  name="password"
                  className="password-reset-form__input"
                  placeholder={I18n.t("password_new")}
                  value={password}
                  onChange={onChange}
                  onBlur={onBlur("password")}
                  autoComplete="new-password"
                  required
                />
                <button
                  type="button"
                  className="password-reset-form__toggle"
                  onClick={this.togglePassword}
                  aria-label="Toggle password visibility"
                >
                  {this.state.showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
              {passwordError && (
                <p className="password-reset-form__error">
                  <Translate value="warning_password" />
                </p>
              )}
              {weakError && (
                <p className="password-reset-form__error">
                  <Translate value="warning_password_weak" />
                </p>
              )}
            </div>

            <div className="password-reset-form__field">
              <label className="password-reset-form__label" htmlFor="reset_password_confirm">
                <Translate value="password_confirm" />
              </label>
              <div
                className={`password-reset-form__input-wrap${
                  confirmError || mismatchError
                    ? " password-reset-form__input-wrap--invalid"
                    : ""
                }`}
              >
                <span className="password-reset-form__input-icon" aria-hidden="true">
                  <FaLock />
                </span>
                <input
                  id="reset_password_confirm"
                  type={this.state.showPasswordConfirm ? "text" : "password"}
                  name="passwordConfirm"
                  className="password-reset-form__input"
                  placeholder={I18n.t("password_confirm")}
                  value={passwordConfirm}
                  onChange={onChange}
                  onBlur={onBlur("passwordConfirm")}
                  autoComplete="new-password"
                  required
                />
                <button
                  type="button"
                  className="password-reset-form__toggle"
                  onClick={this.togglePasswordConfirm}
                  aria-label="Toggle password visibility"
                >
                  {this.state.showPasswordConfirm ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
              {confirmError && (
                <p className="password-reset-form__error">
                  <Translate value="warning_password_confirm" />
                </p>
              )}
              {mismatchError && (
                <p className="password-reset-form__error">
                  <Translate value="warning_password_similar" />
                </p>
              )}
            </div>

            <button
              type="submit"
              className="password-reset-form__submit"
              disabled={submitDisabled || loading}
            >
              {loading ? <MiniLoader /> : <Translate value="password_change" />}
            </button>
          </form>

          <div className="password-reset-card__links">
            <p>
              <Translate value="password_forget_login" />{" "}
              <Link to="/login">
                <Translate value="login" />
              </Link>
            </p>
          </div>

          <p className="password-reset-card__support">
            <Translate value="password_forget_email" />{" "}
            <a href="mailto:team@godiway.com?subject=Godiwayer">
              team@godiway.com
            </a>
          </p>
        </div>
      </div>
    );
  }
}

export default PasswordResetForm;
